/**
 * Assinatura HMAC de eventos (opt-in via config.apiKey).
 * Stub preparado para validação server-side futura.
 */

export async function signEventPayload(
  payload: string,
  secret: string
): Promise<string | undefined> {
  if (!secret || typeof crypto === 'undefined' || !crypto.subtle) {
    return undefined;
  }
  try {
    const key = await crypto.subtle.importKey(
      'raw',
      new TextEncoder().encode(secret),
      { name: 'HMAC', hash: 'SHA-256' },
      false,
      ['sign']
    );
    const sig = await crypto.subtle.sign(
      'HMAC',
      key,
      new TextEncoder().encode(payload)
    );
    return btoa(String.fromCharCode(...new Uint8Array(sig)));
  } catch {
    return undefined;
  }
}
